module.exports = __webpack_public_path__ + "img/donation-settings.c754e0e.svg";